import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-addLarge",
  "use": "icon-addLarge-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-addLarge\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M11.14,11.14V6h1.72v5.14H18v1.72H12.86V18H11.14V12.86H6V11.14Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol